import {ICreateCleanUpForm} from '../index';
import s from '../index.module.scss';

interface Props {
    form: ICreateCleanUpForm;
    onChange: (updates: Partial<ICreateCleanUpForm>) => void;
}

export default function Step5Remarks({form, onChange}: Props) {
    return (
        <div className={s.stepBody}>
            <div className={s.formGroup}>
                <label>Number of Participants</label>
                <input
                    type="number"
                    min="0"
                    value={form.num_of_participant}
                    onChange={(e) => onChange({num_of_participant: e.target.value})}
                    className={s.input}
                    placeholder="e.g., 25"
                />
            </div>

            <div className={s.formGroup}>
                <label>Notes</label>
                <textarea
                    value={form.notes}
                    onChange={(e) => onChange({notes: e.target.value})}
                    className={s.textarea}
                    rows={4}
                    placeholder="Any additional observations or notes..."
                />
            </div>
        </div>
    );
}
